import {datadogLogs, type LogsGlobal} from '@datadog/browser-logs';
import {datadogRum, RumGlobal} from '@datadog/browser-rum';
import {createContext, useContext} from 'react';

export type DatadogContextValue = {
  rum: RumGlobal;
  logs: LogsGlobal;
};

export const DatadogContext = createContext<DatadogContextValue>({
  rum: datadogRum,
  logs: datadogLogs,
});

/**
 * React hook to access the Datadog context containing both RUM and Logs instances.
 * Throws an error if the hook is used outside of a DatadogProvider.
 *
 * @returns The Datadog context value with RUM and Logs
 */
export function useDatadogContext(): DatadogContextValue {
  const context = useContext(DatadogContext);

  if (context == null) {
    throw new Error('useDatadogContext must be used within a DatadogProvider');
  }

  return context;
}
